export enum StagingLevel {
    DEVELOPMENT = 'dev',
    QA = 'qa',
    LOCAL = 'local',
    PRODUCTION = 'prod',
    STAGING = 'stage',
}
